import { kintoneAPIWrapper, type KintoneAppInfo } from './api';

/**
 * kintoneへのリダイレクト時にURLにのせるstateの値を生成する
 * kintoneから戻ってきた際に検証を行う
 * @returns {state<string>}
 */
export function createOAuthStateForKintone(): string {
    const uuid = crypto.randomUUID();
    const state = 'kintone_' + uuid;
    return state
}

/**
 * state,codeの値を見てkintoneからの遷移か判断する。stateの検証は行わないため、適当なuuidでもtrueになる
*/
export function isOAuthRedirect(input: { [key: string]: string; }): boolean {

    if (!input?.state || !input?.code) {
        return false;
    }

    //'kintone_${uuid}'の形の正規表現
    const regex = /^kintone_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return regex.test(input['state']);
}

/**
 * kintone のアプリ一覧を取得する関数。
 * オフセットはkintoneのアプリ一覧の何番からを取得するかの定義(https://cybozu.dev/ja/kintone/docs/rest-api/apps/get-apps/#request)
 * 現状使っているのはオフセットのみなので、他のパラメータは省略している
 * 
 * @param {number} kintoneAppOffset - アプリ一覧の取得開始位置（オフセット）。
 * @returns {Promise<KintoneAppInfo[]>} - 整形済みの kintone アプリ情報の配列。
 * @throws {Error} - API 呼び出しに失敗した場合、例外をスローする。
 * 
 * @example
 * try {
 *   const apps = await getKintoneAppsList(0);
 *   console.log(apps);
 * } catch (error) {
 *   console.error('Failed to get kintone apps:', error);
 * }
 */
export async function getKintoneAppsList(kintoneAppOffset: number): Promise<KintoneAppInfo[]> {
    const appList = await kintoneAPIWrapper('get-apps', JSON.stringify({ offset: kintoneAppOffset }))
    const appListJson = JSON.parse(appList.kintoneResponse)

    return appListJson.apps.map((app: any) => ({
        kintoneAppId: app.appId || '',
        kintoneAppName: app.name || '',
        kintoneAppDescription: app.description || '',
        kintoneAppCreatedAt: app.createdAt || '',
        kintoneAppModifiedAt: app.modifiedAt || ''
    }));
}

export function getUrlQueryParams(): { [key: string]: string } {
    const currentUrl = window.location.href;
    const urlObj = new URL(currentUrl);
    const params: { [key: string]: string } = {};

    // URLSearchParamsをループしてすべてのクエリパラメータをマップに追加
    urlObj.searchParams.forEach((value, key) => {
        params[key] = value;
    });

    return params;
}